"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.IconBackground = exports.FileWrapperButton = exports.FileInfoWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "egqh0xs3"
} : {
  target: "egqh0xs3",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("&>button,&>button>span{width:100%;}&>button:active>span>div{border:1px solid #ccc;}button{cursor:", props.clickable ? 'pointer' : 'initial', ";&:focus{text-decoration:", props.clickable ? 'underline' : 'none', ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const FileWrapperButton = exports.FileWrapperButton = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "egqh0xs2"
} : {
  target: "egqh0xs2",
  label: "FileWrapperButton"
})(props => /*#__PURE__*/(0, _react.css)("display:grid;grid-template-columns:40px 1fr;grid-column-gap:1em;border:1px solid #ccc;border-radius:", props.borderRadius, ";padding:1.4em;background-color:transparent;font-weight:normal;span{text-align:left;}&:hover{cursor:", props.clickable ? 'pointer' : 'initial', ";}&:active{border:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:FileWrapperButton;")));
const FileInfoWrapper = exports.FileInfoWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "egqh0xs1"
} : {
  target: "egqh0xs1",
  label: "FileInfoWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "12uxgl2",
  styles: "display:grid;grid-template-columns:1fr;grid-row-gap:0.1em;span{white-space:pre-wrap;}"
} : {
  name: "12uxgl2",
  styles: "display:grid;grid-template-columns:1fr;grid-row-gap:0.1em;span{white-space:pre-wrap;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const IconBackground = exports.IconBackground = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "egqh0xs0"
} : {
  target: "egqh0xs0",
  label: "IconBackground"
})(props => `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background-color: ${props.background};

    span {
      font-weight: bold;
    }
  `);